import Resource from "./resource";
import request from "../utils/request";

class UserResource extends Resource {
  constructor() {
    // super("accounts");
    super("users");
  }
  /**
   *
   * @param {String} email
   * @param {String} first_name
   * @param {String} last_name
   * @param {String} invitation_link
   * @param {Number} role
   * @returns
   */
  invite(payload) {
    return request.post("/admin/invite/user/", payload);
  }
  getAll(query) {
    return request({
      url: `/admin/${this.uri}/`,
      method: "get",
      params: query,
    });
  }
  updateOne(id, resource) {
    return request({
      url: "/" + this.uri + "/settings/",
      method: "put",
      data: resource,
    });
  }
  /**
   *
   * @param {String} token
   * @param {Object} payload
   * @returns
   */
  acceptInvite(token, payload) {
    return request.post(`/auth/register/${token}/`, payload);
  }
  /**
   * @param {Number} id roleId
   */
  getRole(id) {
    return request.get(`${this.uri}/roles/${id}/`);
  }
  /**
   *
   * @param {Number | String} id roleId
   * @param {String} role role name
   * @returns
   */
  updateRole(data) {
    return request.put(`/admin/user/type/`, data);
  }
}

export default new UserResource();
